import React, { useRef } from 'react';

import { FormikHelpers } from 'formik';

import OnboardingSelect from 'components/Selects/OnboardingSelect';
import useStoreTranslation from 'hooks/useStoreTranslation';

export interface Props {
  value?: string;
  formik?: FormikHelpers<string>;
}

type Option = {
  id: 'Male' | 'Female';
  name: string;
};

const GenderSelect = ({ value, formik }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useStoreTranslation();
  const OPTIONS: Option[] = [
    { id: 'Male', name: t('guestForm.genderValues.male') },
    { id: 'Female', name: t('guestForm.genderValues.female') },
  ];

  const handleChange = (newValue: string) => {
    formik?.setFieldValue('gender', newValue);
  };

  return (
    <div ref={ref}>
      <OnboardingSelect
        title={t('guestForm.genderPlaceHolder')}
        options={OPTIONS}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
};

export default GenderSelect;
